'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';

export default function TransformationCard({ data, onClick }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      onClick={onClick}
      className="relative cursor-pointer w-full rounded-2xl overflow-hidden bg-[#0a0a0a] border border-[#faaf40]/20 hover:border-[#faaf40] transition-all duration-500 shadow-2xl group"
    >
      <div className="grid grid-cols-2 h-[200px] sm:h-[250px] md:h-[300px] relative">
        
        {/* BEFORE IMAGE - Removed dark overlay */}
        <div className="relative border-r border-[#faaf40]/10 overflow-hidden">
          <Image
            src={data.images[0]}
            alt={`${data.name} before`}
            fill
            className="object-cover transition-transform duration-700 group-hover:scale-110"
            sizes="(max-width: 768px) 50vw, 33vw"
          />
          {/* Sirf Label ke peeche halka gradient taake 'Before' parha jaye */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent flex items-end justify-center pb-3">
            <span className="text-[10px] md:text-xs uppercase tracking-widest text-white font-bold bg-black/40 backdrop-blur-md px-3 py-1 rounded-full border border-white/10">
              Before
            </span>
          </div>
        </div>

        {/* AFTER IMAGE - Removed dark overlay */}
        <div className="relative overflow-hidden">
          <Image
            src={data.images[1]}
            alt={`${data.name} after`}
            fill
            className="object-cover transition-transform duration-700 group-hover:scale-110"
            sizes="(max-width: 768px) 50vw, 33vw"
          />
          {/* Sirf Label ke peeche halka gradient */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent flex items-end justify-center pb-3">
            <span className="text-[10px] md:text-xs uppercase tracking-widest text-white font-bold bg-[#faaf40]/90 px-3 py-1 rounded-full shadow-lg">
              After
            </span>
          </div>
        </div>
      </div>

      {/* TEXT CONTENT - Clean and Premium */}
      <div className="p-5 md:p-6 text-center bg-[#0a0a0a]">
        <h2 className="text-xl md:text-2xl font-bold text-[#faaf40] mb-1">
          {data.name}
        </h2>
        
        <p className="text-[10px] md:text-xs uppercase tracking-[0.3em] text-[#faaf40]/70 mb-4">
          {data.title}
        </p>
        
        <p className="text-gray-300 text-xs md:text-sm leading-relaxed line-clamp-3 font-light">
          {data.desc}
        </p>
      </div>

      {/* Subtle Border Glow on Hover */}
      <div className="absolute inset-0 pointer-events-none group-hover:bg-[#faaf40]/5 transition-colors duration-500" />
    </motion.div>
  );
}